import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Switch, message as toaster } from 'antd';
import { useDispatch } from 'react-redux';
import { updateStatus } from 'store/commonSlice';
import { updateEmployeeStatusV2 } from 'store/employeeSliceV2';
import { getUIVersion } from 'utils/router-static-data';

const { confirm } = Modal;

/**
 * Employee-specific status action component
 * Handles both V1 and V2 API calls based on UI version
 */
export default function EmployeeStatusAction({ id, statusData = false }) {
	const dispatch = useDispatch();
	const uiVersion = getUIVersion();
	const useV2API = uiVersion === 'new';

	function handleOk() {
		if (useV2API) {
			// V2 API
			dispatch(
				updateEmployeeStatusV2({
					id,
					is_active: !statusData,
				})
			)
				.then(() => {
					toaster.success('Status updated successfully');
					setTimeout(() => {
						window.location.reload();
					}, 500);
				})
				.catch(() => {
					toaster.error('Failed to update status');
				});
		} else {
			// V1 API
			const data = {
				update_type: 'status',
				data: { id, type: 'employee', is_active: !statusData },
			};

			dispatch(updateStatus(data))
				.then(() => {
					toaster.success('Status updated successfully');
					setTimeout(() => {
						window.location.reload();
					}, 500);
				})
				.catch(() => {
					toaster.error('Failed to update status');
				});
		}
	}

	function showConfirm() {
		const status = statusData === true ? 'Inactive' : 'Active';
		confirm({
			title: `Do you want to change the status to ${status}?`,
			onOk() {
				handleOk();
			},
		});
	}

	return (
		<Switch
			checked={statusData}
			onChange={showConfirm}
			checkedChildren="Active"
			unCheckedChildren="InActive"
		/>
	);
}

EmployeeStatusAction.propTypes = {
	statusData: PropTypes.bool,
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
